import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PlanSvg from 'images/v5/icons/file-check-01.svg';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import StatusBadge from 'layout/atoms/StatusBadge';
import Grid from 'layout/molecules/Grid/Grid';
import { useAppDispatch } from 'store/index';
import { selectModalByName } from 'store/layoutSlice';
import { selectOrderDetailsItem } from 'store/orderDetailsSlice';
import { setOrderSpecificationPriority } from 'store/orderProductionManagerSlice';
function SetPriority() {
    var _a;
    const { t } = useTranslation(['orders', 'common']);
    const dispatch = useAppDispatch();
    const orderDaetials = useSelector(selectOrderDetailsItem);
    const modalData = (_a = useSelector(selectModalByName('setPriority'))) === null || _a === void 0 ? void 0 : _a.data;
    const handleChange = (priority) => {
        if (!(orderDaetials === null || orderDaetials === void 0 ? void 0 : orderDaetials.id) || !(modalData === null || modalData === void 0 ? void 0 : modalData.specificationId)) {
            return;
        }
        dispatch(setOrderSpecificationPriority({
            orderId: orderDaetials.id,
            specificationId: modalData.specificationId,
            priority,
        }));
        dispatch({ type: 'layout/closeModal', payload: { name: 'setPriority' } });
    };
    return (React.createElement(Modal, { alwaysScroll: true, name: "setPriority", size: "xs", header: React.createElement(Label, { weight: "strong" },
            React.createElement(PlanSvg, null),
            t('SET_PRIORITY')) },
        React.createElement(Grid, { columns: 1, gap: 24 },
            React.createElement(Grid, { columns: 3, gap: 6 },
                React.createElement(StatusBadge, { size: "l", theme: "fill", color: "positive", onClick: () => handleChange('HIGH') }, t('PRIORITY_HIGH')),
                React.createElement(StatusBadge, { noIcon: true, size: "l", theme: "fill", color: "neutral", onClick: () => handleChange('NEUTRAL') }, t('PRIORITY_NEUTRAL')),
                React.createElement(StatusBadge, { size: "l", theme: "fill", color: "negative", onClick: () => handleChange('LOW') }, t('PRIORITY_LOW'))))));
}
export default memo(SetPriority);
